import { LoaderActions } from '@store/loaders'
import { PERSONAL_WORKSPACE_ID } from '@store/reducers/dashboard/constants'
import { parseNestError } from '@store/reducers/dashboard/utils'
import {
  LimitReachedActions,
  PROJECTS_LIMIT_REACHED,
} from '@store/reducers/limitReached'
import { managerActions } from '@store/reducers/manager/actions'
import { ErrorNotification } from '@storeOld/reducers/notification'
import { call, put } from 'redux-saga/effects'

import { NestClient } from '@/nest'
import type { DashboardActions } from '../../actions'

export function* create({
  payload: { workspaceId },
}: ReturnType<typeof DashboardActions.projects.create>) {
  yield put(LoaderActions.set('dashboard_new_project'))

  try {
    const canCreate: boolean = yield call(
      NestClient.projects.canCreate,
      workspaceId
    )

    if (!canCreate) {
      return
    }

    const teamId = workspaceId === PERSONAL_WORKSPACE_ID ? null : workspaceId

    yield put(managerActions.createProjectAndSaveSaga({ teamId }))
  } catch (error) {
    const message = parseNestError(error)

    if (message === PROJECTS_LIMIT_REACHED) {
      yield put(LimitReachedActions.alert())

      return
    }

    yield put(ErrorNotification(message))
  } finally {
    yield put(LoaderActions.unset('dashboard_new_project'))
  }
}
